import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { MeasureNotifier } from './measure-notifier';
import { MeasureState } from './measure-state';

@Injectable()
export class MeasureProvider extends BaseProvider<MeasureNotifier, MeasureState> {
  constructor() {
    super(MeasureNotifier);
    this.trackSessionReset(() => this.notifier.resetState());
  }
}
